/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_User_TitleInputs */

const es_walkthrough_user_title = /** @type {(inputs: Walkthrough_User_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu Perfil`)
};

const en_walkthrough_user_title = /** @type {(inputs: Walkthrough_User_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Profile`)
};

/**
* | output |
* | --- |
* | "Your Profile" |
*
* @param {Walkthrough_User_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_user_title = /** @type {((inputs?: Walkthrough_User_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_User_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_user_title(inputs)
	return en_walkthrough_user_title(inputs)
});
export { walkthrough_user_title as "walkthrough.user_title" }